module.exports = __webpack_public_path__ + "media/images/themes/light/epic-games-light-e0aa48b8860ccb968ac61a2f5fb6b349.svg";